import { labelWidth } from '../../../HMISection/Data/P710/P710.data';

const paddingtopLabels = '5px 25px 0px 0px';
export const DielectricConstantP8181 = (formData) => ({
    rows: [
        {
            key: 1,
            fields: [{
                key: 'Nodata',
                isLabel: true,
                xs: 2
            },
            {
                key: 'F1047MeasuredDielectricConstantUpperLabel',
                label: 'Upper Liquid',
                xs: 2,
                isLabel: true,
                textAlign: 'center',
                fontWeight: '600',
                labelWidth,
                fontSize: '9pt',
                marginTop: '5px',
                padding: paddingtopLabels
            },
            {
                key: 'F1049MeasuredDielectricConstantLowerLabel',
                label: 'Lower Liquid',
                xs: 2,
                isLabel: true,
                textAlign: 'center',
                fontWeight: '600',
                labelWidth,
                fontSize: '9pt',
                marginTop: '5px',
                padding: paddingtopLabels
            },
            {
                key: 'Nodata',
                isLabel: true,
                xs: 2
            },
            {
                key: 'F1048ConfiguredDielectricConstantUpperLabel',
                label: 'Upper Liquid',
                xs: 2,
                isLabel: true,
                textAlign: 'center',
                fontWeight: '600',
                labelWidth,
                fontSize: '9pt',
                marginTop: '5px',
                padding: paddingtopLabels
            },
            {
                key: 'F1050ConfiguredDielectricConstantLowerLabel',
                label: 'Lower Liquid',
                xs: 2,
                isLabel: true,
                textAlign: 'center',
                fontWeight: '600',
                labelWidth,
                fontSize: '9pt',
                marginTop: '5px',
                padding: paddingtopLabels
            }
            ]
        },
        {
            key: 2,
            fields: [{
                key: 'F1047MeasuredDielectricConstantLabel',
                label: 'Measured Dielectric Constant (DC)',
                xs: 2,
                isLabel: true,
                fontWeight: '600',
                labelWidth,
                fontSize: '9pt'
            },
            {
                key: 'F1047MeasuredDielectricConstant',
                value: formData.F1047MeasuredDielectricConstant,
                xs: 2,
                labelWidth: '0%',
                textAlign: 'center',
                width: '100%',
                height: '1.2rem',
                marginTop: '5px',
                type: 'number',
                maxLength: '10',
                borderRight: '0'
            },
            {
                key: 'F1049MeasuredDielectricConstantLower',
                value: formData.F1049MeasuredDielectricConstantLower,
                xs: 2,
                labelWidth: '0%',
                textAlign: 'center',
                width: '100%',
                height: '1.2rem',
                marginTop: '5px',
                type: 'number',
                maxLength: '10'
            },
            {
                key: 'F1048ConfiguredDielectricConstantLabel',
                label: 'Configured Dielectric Constant (DC)',
                xs: 2,
                isLabel: true,
                fontWeight: '600',
                labelWidth,
                fontSize: '9pt',
                textAlign: 'right'
            },
            {
                key: 'F1048ConfiguredDielectricConstant',
                value: formData.F1048ConfiguredDielectricConstant,
                xs: 2,
                width: '100%',
                labelWidth: '0%',
                textAlign: 'center',
                marginTop: '5px',
                height: '1.2rem',
                type: 'number',
                maxLength: '10',
                marginRight: '0',
                borderRight: '0'
            },
            {
                key: 'F1050ConfiguredDielectricConstantLower',
                value: formData.F1050ConfiguredDielectricConstantLower,
                xs: 2,
                width: '100%',
                labelWidth: '0%',
                textAlign: 'center',
                marginTop: '5px',
                height: '1.2rem',
                type: 'number',
                maxLength: '10',
                marginRight: '0'
            }
            ]
        }
    ]
});
